export const status = {
  scheduled: 'Agendado',
  delayed: 'Atrasado',
  attended: 'Atendido',
  absent: 'Ausente',
  canceled: 'Cancelado',
  in_attendance: 'Em Atendimento',
  present: 'Presente'
}

export const getOptionsStatus = () => {
  return Object.keys(status).map((key) => {
    return {
      id: key,
      label: status[key]
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/index/resources/dataStatus.js